<template>
	<div>
		<div
			class="c-mask z-index-level-3"
			:class="{ isActive: !isActive }"
			@click="circleNav()"
		></div>
		<nav
			id="c-circle-nav"
			class="c-circle-nav z-index-level-3"
			:class="{ isActive: !isActive }"
			@click="circleNav()"
		>
			<div
				id="c-circle-nav__toggle"
				class="c-circle-nav__toggle z-index-level-2"
				:class="{ isActive: !isActive }"
			></div>
			<ul class="c-circle-nav__items">
				<li
					class="c-circle-nav__item"
					v-for="item in apps"
					:key="item.id"
				>
					<span class="c-circle-nav__title"> {{ item.appName }}</span>
					<div style="background-color: white; border-radius: 50%">
						<a
							target="_blank"
							:href="item.url"
							class="c-circle-nav__link"
						>
							<img
								:src="imageUrl + item.image"
								alt="icon"
								style="width: 25px; height: 25px"
							/>
						</a>
					</div>
				</li>

				<!-- more items here -->
			</ul>
		</nav>
	</div>
</template>

<script>
// import constants from "../../constants";

export default {
	name: "CircleNav",

	data() {
		return {
			isActive: true,
			extendApps: [
				"ework",
				"mobimeeting",
				"eoffice",
				"eofficeMbf",
				"ecollab",
			],
			// VUE_APP_SSO_IMAGES_URL đã gỡ; apps() trả [] nên imageUrl không còn dùng.
			imageUrl: "",
		};
	},
	watch: {},
	computed: {
		apps() {
			// workspaceApps chỉ phục vụ SSO (đã gỡ) — không còn nguồn dữ liệu.
			return [];
		},
	},
	methods: {
		circleNav() {
			this.isActive = !this.isActive;
		},
	},
};
</script>

<style scoped>
.c-circle-nav {
	position: fixed;
	bottom: 15px;
	right: 15px;
	width: 54px;
	height: 54px;
	border-radius: 50%;
	border: 3px solid rgba(45, 61, 79, 0.1);
	filter: drop-shadow(-3px 0px 10px rgba(45, 61, 79, 0.1))
		drop-shadow(0px 3px 10px rgba(45, 61, 79, 0.1));
}

.c-circle-nav__items {
	display: block;
	list-style: none;
	position: absolute;
	margin: 0;
	padding: 0;
}

.c-circle-nav__item {
	display: block;
	position: absolute;
	top: 0;
	left: 0;
	width: 48px;
	height: 48px;
	border-radius: 50%;
	opacity: 0;
	-webkit-transition-property: -webkit-transform, opacity;
	transition-property: transform, opacity;
	-webkit-transition-duration: 0.3s, 0.3s;
	transition-duration: 0.3s, 0.3s;
	-webkit-transition-timing-function: cubic-bezier(0.35, -0.59, 0.47, 0.97);
	transition-timing-function: cubic-bezier(0.35, -0.59, 0.47, 0.97);
}

/**
* Transition delays at the default state.
*/

.c-circle-nav__item:nth-child(1) {
	-webkit-transition-delay: 0.4s;
	transition-delay: 0.4s;
}

.c-circle-nav__item:nth-child(2) {
	-webkit-transition-delay: 0.3s;
	transition-delay: 0.3s;
}

.c-circle-nav__item:nth-child(3) {
	-webkit-transition-delay: 0.2s;
	transition-delay: 0.2s;
}

.c-circle-nav__item:nth-child(4) {
	-webkit-transition-delay: 0.1s;
	transition-delay: 0.1s;
}

.c-circle-nav__item:nth-child(5) {
	-webkit-transition-delay: 0s;
	transition-delay: 0s;
}

.c-circle-nav.isActive .c-circle-nav__item {
	-webkit-transition-timing-function: cubic-bezier(0.35, 0.03, 0.47, 1.59);
	transition-timing-function: cubic-bezier(0.35, 0.03, 0.47, 1.59);
}

.c-circle-nav.isActive .c-circle-nav__item:nth-child(1) {
	-webkit-transition-delay: 0s;
	transition-delay: 0s;
	-webkit-transform: translate(-144px, 0);
	-ms-transform: translate(-144px, 0);
	transform: translate(-144px, 0);
}

.c-circle-nav.isActive .c-circle-nav__item:nth-child(2) {
	-webkit-transition-delay: 0.1s;
	transition-delay: 0.1s;
	-webkit-transform: translate(-134px, -56px);
	-ms-transform: translate(-134px, -56px);
	transform: translate(-134px, -56px);
	transform: translate(-122px, -68px);
}

.c-circle-nav.isActive .c-circle-nav__item:nth-child(3) {
	-webkit-transition-delay: 0.2s;
	transition-delay: 0.2s;
	-webkit-transform: translate(-102px, -102px);
	-ms-transform: translate(-102px, -102px);
	transform: translate(-102px, -102px);
	transform: translate(-77px, -125px);
}
.c-circle-nav__title {
	font-family: "Roboto";
	font-style: normal;
	font-weight: 500;
	font-size: 13px;
	line-height: 17px;
	margin-right: 8px;
	/* identical to box height, or 131% */

	display: none;
	align-items: center;
	text-align: center;
	width: 120px;
	color: #ffffff;

	text-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);

	/* Inside auto layout */
	justify-content: flex-end;
	flex: none;
	order: 0;
	flex-grow: 0;
	position: absolute;
	top: 40%;
	right: 48px;
}

.c-circle-nav.isActive .c-circle-nav__item:nth-child(4) {
	-webkit-transition-delay: 0.3s;
	transition-delay: 0.3s;
	-webkit-transform: translate(-56px, -134px);
	-ms-transform: translate(-56px, -134px);
	transform: translate(-56px, -134px);
	transform: translate(-17px, -169px);
}

.c-circle-nav.isActive .c-circle-nav__item:nth-child(5) {
	-webkit-transition-delay: 0.4s;
	transition-delay: 0.4s;
	-webkit-transform: translate(0, -144px);
	-ms-transform: translate(0, -144px);
	transform: translate(0, -144px);
}

.c-circle-nav.isActive .c-circle-nav__item {
	opacity: 1;
}

.c-circle-nav__link {
	display: block;
	width: 48px;
	height: 48px;
	border-radius: 50%;
	padding: 12px;
	box-shadow: inset 0 0 0 2px #fff;
}

.c-circle-nav__link img {
	display: block;
	max-width: 100%;
	height: auto;
}

.c-circle-nav__link:hover {
	box-shadow: inset 0 0 0 2px #ff283c;
}

.c-circle-nav__toggle {
	display: block;
	position: absolute;
	margin: 0;
	padding: 0;
	width: 48px;
	height: 48px;
	border: 10px solid #ff283c;
	background-color: #ff283c;
	background-image: url(../../assets/img/Vector2.png);
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	font: inherit;
	font-size: 0;
	text-indent: -9999px;
	border-radius: 50%;
	-webkit-transition: background 0.3s;
	transition: background 0.3s;

	/* reset some browser defaults */

	cursor: pointer;
	/*border: none;*/
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	box-shadow: none;

	filter: drop-shadow(-3px 0px 10px rgba(45, 61, 79, 0.1))
		drop-shadow(0px 3px 10px rgba(45, 61, 79, 0.1));
}

.c-circle-nav__toggle:hover,
.c-circle-nav__toggle:focus {
	outline: none;
	filter: drop-shadow(-3px 0px 10px rgba(45, 61, 79, 0.1))
		drop-shadow(0px 3px 10px rgba(45, 61, 79, 0.1));
}
.c-circle-nav__toggle.isActive {
	outline: none;
	border: 10px solid #c10012 !important;
	background-color: #c10012 !important;
}
.c-circle-nav__item:hover .c-circle-nav__title {
	display: flex;
}
/*.c-circle-nav__toggle span {*/
/*  display: block;*/
/*  position: absolute;*/
/*  height: 4px;*/
/*  background: #fff;*/
/*  border-radius: 1px;*/
/*}*/

.c-circle-nav__toggle span {
	top: 22px;
	left: 10px;
	right: 10px;
	-webkit-transition: background 0.3s;
	transition: background 0.3s;
}

.c-circle-nav__toggle.isActive span {
	background: none;
}

.c-mask {
	position: fixed;
	top: 0;
	left: 0;
	visibility: hidden;
	/*opacity: 0;*/
	width: 100%;
	height: 100%;
	/*background-color: rgba(0, 0, 0, 0.3);*/
	background: #000000;
	opacity: 0.5;
	-webkit-transition: opacity 0.3s, visibility 0.3s;
	transition: opacity 0.3s, visibility 0.3s;
}

.c-mask.isActive {
	/*opacity: 1;*/
	visibility: visible;
}
</style>
